/* eslint-disable class-methods-use-this */

import nextStepsMocks, {
  prepaidTexts,
  postpaidOnlineTexts,
} from './__mocks__/nextSteps.response.mocks'

import { NextStep } from '../model/legal.model'

export default class NextStepsService {
  constructor(private host: string) {}

  fetchNextSteps({
    isPostpaid,
    isOffline,
  }: {
    isPostpaid: boolean
    isOffline: boolean
  }): Promise<NextStep[]> {
    return new Promise((resolve) => {
      if (!isPostpaid) resolve([...nextStepsMocks, ...prepaidTexts])
      if (!isOffline) resolve([...nextStepsMocks, ...postpaidOnlineTexts])
      resolve(nextStepsMocks)
    })
  }
}
